import { useOriginLink } from "../../../app/navigation/return-navigation.js";
import { Card } from "@peer-start/ui";
import { BrainCircuit } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ActionLink } from "../../../app/components/ActionLink.js";
import { AreaAssessmentEntry } from "../../passport/components/AreaAssessmentEntry.js";
import { useAssessments, useLatestAssessment } from "../api/queries.js";
import { KnowledgeStatus } from "./KnowledgeStatus.js";

export function AssessmentPassportCard({
  stampId,
  pageId,
  title,
}: {
  stampId: string;
  pageId: string;
  title: string;
}) {
  const { t } = useTranslation();
  const originLink = useOriginLink();
  const banks = useAssessments();
  const bank = banks.data?.find((assessment) => assessment.stampId === stampId);
  const latest = useLatestAssessment(bank?.id ?? "");
  if (!bank) return <AreaAssessmentEntry pageId={pageId} title={title} />;
  const target = `/me/assessment/${pageId}?assessment=${encodeURIComponent(bank.id)}`;
  return (
    <Card>
      <ActionLink
        controlId="passport.knowledge-assessment"
        to={originLink(latest.data ? `${target}&result=${latest.data.attemptId}` : target)}
        icon={<BrainCircuit aria-hidden="true" className="size-5" />}
        title={bank.title}
        description={t(latest.data ? "knowledgeAssessment.savedResult" : "knowledgeAssessment.introTitle")}
      />
      {latest.data ? (
        <>
          <p className="mt-4 text-sm text-muted-foreground">{t("knowledgeAssessment.passportNote")}</p>
          <ul className="mt-3 space-y-3">
            {latest.data.skills.map((skill) => (
              <li key={skill.id} className="flex flex-wrap items-center justify-between gap-2 text-sm">
                <span>{skill.title}</span>
                <KnowledgeStatus status={skill.status} />
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </Card>
  );
}
